/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminOnboardingAcknowledgmentRequest
 */
export interface AdminOnboardingAcknowledgmentRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminOnboardingAcknowledgmentRequest
     */
    value: boolean;
}

/**
 * Check if a given object implements the AdminOnboardingAcknowledgmentRequest interface.
 */
export function instanceOfAdminOnboardingAcknowledgmentRequest(value: object): value is AdminOnboardingAcknowledgmentRequest {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function AdminOnboardingAcknowledgmentRequestFromJSON(json: any): AdminOnboardingAcknowledgmentRequest {
    return AdminOnboardingAcknowledgmentRequestFromJSONTyped(json, false);
}

export function AdminOnboardingAcknowledgmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminOnboardingAcknowledgmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function AdminOnboardingAcknowledgmentRequestToJSON(value?: AdminOnboardingAcknowledgmentRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

